// extracted by mini-css-extract-plugin
module.exports = {"events":"events_events__2pY2C","events__title":"events_events__title__3ycHl","events__content":"events_events__content__1BYjE"};